import BenefitDocumentUpload from "../../../components/BenefitDocumentUpload";
import httpClient from "../../../services/httpClient";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function AddReports() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const apiPath = async (formData, setUploadProgress) => {
    await httpClient.post("/hrdocuments", formData, {
      withAuth: true,
      config: {
        onUploadProgress: (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setUploadProgress(progress);
        },
      },
    });
  };

  return (
    <BenefitDocumentUpload
      submitLabel={t("documentEditor.addReport")}
      onSuccess={() => {}}
      onError={(msg) => {}}
      apiPath={apiPath}
      category="documents"
      subCategory="reports"
      navigateTo={() => navigate("/administrator/pliki/dokumenty/raporty")}
    />
  );
}

export default AddReports;